import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — estado de cuenta (ledger, admin-billing-ledger.md) + pagos y notas-
// crédito (admin-billing-payments.md). Doble-partida: saldo = Σdébitos − Σcréditos
// (cuenta débito-normal → saldo>0 = el dueño DEBE). Permiso billing:*.

export function useAccountStatement(client, range) {
    return useQuery({
        queryKey: billingKeys.account(client, range),
        queryFn:  ({ signal }) => api.get(billingPaths.account(client), { params: range, signal }).then(r => r.data),
        enabled:  !!client,
        placeholderData: (prev) => prev,
    });
}

export function useCreatePayment() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.payments(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useCreateCreditNote() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.creditNotes(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}
